import * as React from 'react';

import type { FilterVM } from 'ab-viewModels/scheduleBoard/filter';

import type { ScheduleBoardFilterGroup } from '@acceligentllc/shared/enums/scheduleBoardFilterGroup';

import { Button } from '@acceligentllc/storybook';

import FilterItem from './FilterItem';

interface Props {
	label: string;
	options: FilterVM[];
	filterGroup: ScheduleBoardFilterGroup;
	onCheck: (value: FilterVM) => void;
	onCheckAll: (checked: boolean, filterGroup: ScheduleBoardFilterGroup) => void;
}

interface State {
	isExpanded: boolean;
}

export default class FilterGroup extends React.Component<Props, State> {

	state: State = {
		isExpanded: false,
	};

	renderFilterItem = (props: FilterVM) => {
		const { onCheck } = this.props;

		return (
			<FilterItem
				key={`${props.filterGroup}-${props.id}`}
				{...props}
				onCheck={onCheck}
			/>
		);
	};

	showAll = () => {
		const { onCheckAll, filterGroup } = this.props;
		onCheckAll(true, filterGroup);
	};

	hideAll = () => {
		const { onCheckAll, filterGroup } = this.props;
		onCheckAll(false, filterGroup);
	};

	toggleExpand = () => {
		this.setState(({ isExpanded }) => ({ isExpanded: !isExpanded }));
	};

	render() {
		const { label, options } = this.props;
		const { isExpanded } = this.state;

		let optionsClass = 'filter-modal__options';
		optionsClass = !isExpanded ? `${optionsClass} filter-modal__options--hidden` : optionsClass;

		return (
			<div className="filter-modal__group">
				<div className="filter-modal__group-header">
					<span className="filter-modal__group-header-label">
						<Button
							icon={isExpanded ? 'ActionCollapsedOutline' : 'ActionExpandedOutline'}
							label={label}
							onClick={this.toggleExpand}
							style="link"
						/>
					</span>
					<div className="filter-modal__group-header-buttons">
						{isExpanded &&
							<>
								<Button
									label="Show All"
									onClick={this.showAll}
									size="small"
									style="link"
								/>
								<Button
									label="Hide All"
									onClick={this.hideAll}
									size="small"
									style="link"
								/>
							</>
						}
					</div>
				</div>
				<div className={optionsClass}>
					{options.length ? options.map(this.renderFilterItem) : 'Not available.'}
				</div>
			</div>
		);
	}
}
